'use strict';

var React = require('react');
require('prop-types');
var TextField = require('../../node_modules/@material-ui/core/esm/TextField/TextField.js');
var MenuItem = require('../../node_modules/@material-ui/core/esm/MenuItem/MenuItem.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

var styles = {
  menu: {
    maxHeight: 500
  }
};

function createYearsArray(startYear, endYear) {
  var years = [];

  for (var year = endYear; year >= startYear; year--) {
    years.push(year.toString());
  }

  return years;
}

function YearsDropdown(_ref) {
  var endingYear = _ref.endingYear,
      yearSelectionRange = _ref.yearSelectionRange,
      inputLabel = _ref.inputLabel,
      selectedYear = _ref.selectedYear,
      handleChange = _ref.handleChange,
      classes = _ref.classes,
      defaultSelection = _ref.defaultSelection;
  var years = createYearsArray(endingYear - yearSelectionRange, endingYear);
  return React__default["default"].createElement(TextField["default"], {
    fullWidth: true,
    select: true,
    label: inputLabel,
    value: selectedYear,
    onChange: function onChange(event) {
      handleChange(event.target.value);
    },
    SelectProps: {
      MenuProps: {
        className: classes.menu
      }
    },
    margin: "normal",
    variant: "outlined"
  }, React__default["default"].createElement(MenuItem["default"], {
    value: ""
  }, defaultSelection), years.map(function (year, index) {
    return React__default["default"].createElement(MenuItem["default"], {
      value: year,
      key: index
    }, year);
  }));
}

YearsDropdown.defaultProps = {
  inputLabel: 'Please select your starting year',
  defaultSelection: 'Please select your starting year',
  endingYear: new Date().getFullYear(),
  yearSelectionRange: 30,
  selectedYear: '',
  handleChange: function handleChange() {}
};
var YearsDropdown$1 = withStyles(styles)(YearsDropdown);

module.exports = YearsDropdown$1;
